import { AxiosError } from 'axios'
import toast from 'react-hot-toast'
import { CustomObject } from 'types/common'

const handleError = (
  error: unknown,
  toastId: string,
  errorCodeMap?: CustomObject,
  duration: number = 3000,
) => {
  const defaultMessage =
    errorCodeMap?.['default'] ?? 'An unexpected error occurred.'

  if (error instanceof AxiosError) {
    const code = error?.response?.data?.errors?.msg

    const message =
      code?.runningService ||
      errorCodeMap?.[code] ||
      (typeof code?.[0]?.msg === 'string' && code[0].msg) ||
      (typeof code === 'string' ? code : undefined) ||
      defaultMessage

    return toast.error(message, { id: toastId, duration })
  }

  // Non-Axios Error Handling (e.g., native errors, unknowns)
  const message =
    (error as any)?.message || (error as any)?.toString?.() || defaultMessage

  return toast.error(message, { id: toastId, duration })
}

export { handleError }
